import { autoEffect } from '@risingstack/react-easy-state'
import config from '../config'

export const debug = (() => {
  if (config.debug) return (...args) => { console.debug(...args) }
  return () => {}
})()

export const storeDebugger = (name, store) => {
  if (config.debug) {
    autoEffect(() => debug(`[store][${name}] updated`, JSON.parse(JSON.stringify(store))))
  }
}



// WEBPACK FOOTER //
// ./src/utilities/logger.js